import React, {PureComponent} from 'react'

import Button from 'rambler-ui/Button'
import {throttle} from 'rambler-ui/utils/raf'
import withStyles from 'isomorphic-style-loader/withStyles'

import Title from 'components/Title'
import {logos} from 'components/logos/products'
import RamblerIdLogo from 'components/logos/RamblerIdLogo'

import styles from './styles.module.css'

class Products extends PureComponent {
  state = {width: 0}

  componentDidMount() {
    this.updateWindowWidth()
    this.updateWindowWidth = throttle(this.updateWindowWidth)
    window.addEventListener('resize', this.updateWindowWidth)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth)
  }

  updateWindowWidth = () => {
    this.setState(() => ({width: window.innerWidth}))
  }

  render() {
    const {width} = this.state
    let logosView = ''

    // To prevent logos from rendering in ssr version
    if (width > 0) {
      logosView = logos.map(({domain, desktop, mobile, Icon}) => (
        <li key={domain}>
          <a
            href={`https://${domain}`}
            target="_blank"
            rel="noreferrer noopener">
            <Icon
              width={width >= 1024 ? desktop : mobile}
              height={width >= 1024 ? 50 : 30}
            />
          </a>
        </li>
      ))
    }

    return (
      <section id="products" className={styles.products}>
        <div className={styles.content}>
          <div className={styles.heading}>
            <Title type="products" level={2}>
              Используйте один профиль для всех проектов Rambler&Co
            </Title>
            <div className={styles.ramblerId}>
              <RamblerIdLogo />
            </div>
          </div>
          <ul className={styles.list}>{logosView}</ul>
          {this.props.loggedIn === true ? (
            <Button
              href="https://id.rambler.ru/account/profile"
              className={styles.ctaButton}
              rounded>
              Перейти в профиль
            </Button>
          ) : null}
        </div>
      </section>
    )
  }
}

export default withStyles(styles)(Products)
